import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const setTransportationTypeOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      roundId: string;
      transportationTypeId: string;
      isTargetingAll: boolean;
      targetRoundIds?: string[];
    }
  ) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) {
      return;
    }
    const targetRoundIdSet =
      payload.isTargetingAll && payload.targetRoundIds
        ? new Set(payload.targetRoundIds)
        : null;

    const updatedRounds = currentBooking.rounds.map((round) => {
      if (
        payload.isTargetingAll
          ? targetRoundIdSet?.has(round.localId) ?? false
          : round.localId === payload.roundId
      ) {
        return {
          ...round,
          transportationType: { id: payload.transportationTypeId },
        };
      }
      return round;
    });
    const newBooking = {
      ...currentBooking,
      rounds: updatedRounds,
    };
    set(currentBookingAtom, newBooking);
  }
);
